import { render, staticRenderFns } from "./Triangle.vue?vue&type=template&id=0387cf30&scoped=true&"
import script from "./Triangle.vue?vue&type=script&lang=js&"
export * from "./Triangle.vue?vue&type=script&lang=js&"
import style0 from "./Triangle.vue?vue&type=style&index=0&id=0387cf30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0387cf30",
  null
  
)

export default component.exports